import {
  bodyBold50,
  bodyBold100,
  bodyBold150,
  bodyBold200,
  bodyRegular50,
  bodyRegular100,
  bodyRegular150,
  bodyRegular200,
  eyebrow50,
  eyebrow150,
  eyebrow250,
  headingBlack800,
  headingBlack1000,
  headingBold300,
  headingBold400,
  headingBold500,
  headingBold600,
  headingBold800,
  headingBold1000,
  headingExpressive600,
  headingExpressive800,
  headingExpressive1000,
  headingLight600,
  headingLight800,
  headingLight1000,
  labelBold100,
  labelBold150,
  labelBold200,
  labelMedium100,
  labelMedium150,
  labelMedium200,
  linkBold50,
  linkBold100,
  linkBold150,
  linkBold200,
  linkRegular50,
  linkRegular100,
  linkRegular150,
  linkRegular200,
  numericRegular300,
  numericRegular400,
  numericRegular500,
  numericRegular600,
} from './typography';
import { TextProps } from './typographyTypes';
import styled from 'styled-components';

export const remDivider = 16;

export const MDSBrandText = {
  BodyBold50: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold50.rem] / remDivider}rem;
  `,

  BodyBold100: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold100.rem] / remDivider}rem;
  `,

  BodyBold150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold150.rem] / remDivider}rem;
  `,

  BodyBold200: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold200.rem] / remDivider}rem;
  `,

  BodyRegular50: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular50.rem] / remDivider}rem;
  `,

  BodyRegular100: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular100.rem] / remDivider}rem;
  `,

  BodyRegular150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular150.rem] / remDivider}rem;
  `,

  BodyRegular200: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular200.rem] / remDivider}rem;
  `,

  Eyebrow50: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[eyebrow50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        eyebrow50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[eyebrow50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[eyebrow50.rem] / remDivider}rem;
    letter-spacing: ${eyebrow50.letterSpacing};
    text-transform: ${eyebrow50.textTransform};
  `,

  Eyebrow150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[eyebrow150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        eyebrow150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[eyebrow150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[eyebrow150.rem] / remDivider}rem;
    letter-spacing: ${eyebrow150.letterSpacing};
    text-transform: ${eyebrow150.textTransform};
  `,

  Eyebrow250: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[eyebrow250.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        eyebrow250.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[eyebrow250.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[eyebrow250.rem] / remDivider}rem;
    letter-spacing: ${eyebrow250.letterSpacing};
    text-transform: ${eyebrow250.textTransform};
  `,

  NumericRegular600: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[numericRegular600.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        numericRegular600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[numericRegular600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[numericRegular600.rem] / remDivider}rem;
  `,

  NumericRegular500: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[numericRegular500.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        numericRegular500.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[numericRegular500.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[numericRegular500.rem] / remDivider}rem;
  `,

  NumericRegular400: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[numericRegular400.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        numericRegular400.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[numericRegular400.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[numericRegular400.rem] / remDivider}rem;
  `,

  NumericRegular300: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[numericRegular300.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        numericRegular300.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[numericRegular300.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[numericRegular300.rem] / remDivider}rem;
  `,

  HeadingBlack800: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBlack800.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBlack800.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBlack800.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBlack800.rem] / remDivider}rem;
  `,

  HeadingBlack1000: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBlack1000.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBlack1000.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBlack1000.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBlack1000.rem] / remDivider}rem;
  `,

  HeadingExpressive600: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) => p.theme.font.secondary};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingExpressive600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingExpressive600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingExpressive600.rem] / remDivider}rem;
  `,

  HeadingExpressive800: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingExpressive800.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingExpressive800.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingExpressive800.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingExpressive800.rem] / remDivider}rem;
  `,

  HeadingExpressive1000: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingExpressive1000.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingExpressive1000.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingExpressive1000.lineHeight] / remDivider}rem;
    font-size: ${(p) =>
      p.theme.size[headingExpressive1000.rem] / remDivider}rem;
  `,

  HeadingLight600: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingLight600.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingLight600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingLight600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingLight600.rem] / remDivider}rem;
  `,

  HeadingLight800: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingLight800.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingLight800.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingLight800.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingLight800.rem] / remDivider}rem;
  `,

  HeadingLight1000: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingLight1000.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingLight1000.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingLight1000.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingLight1000.rem] / remDivider}rem;
  `,

  HeadingBold1000: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold1000.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold1000.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold1000.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold1000.rem] / remDivider}rem;
  `,

  HeadingBold800: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold800.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold800.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold800.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold800.rem] / remDivider}rem;
  `,

  HeadingBold600: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold600.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold600.rem] / remDivider}rem;
  `,

  HeadingBold500: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold500.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold500.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold500.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold500.rem] / remDivider}rem;
  `,

  HeadingBold400: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold400.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold400.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold400.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold400.rem] / remDivider}rem;
  `,

  HeadingBold300: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold300.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold300.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold300.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold300.rem] / remDivider}rem;
  `,

  LabelBold100: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold100.rem] / remDivider}rem;
  `,

  LabelBold150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold150.rem] / remDivider}rem;
  `,

  LabelBold200: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold200.rem] / remDivider}rem;
  `,

  LabelMedium100: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium100.rem] / remDivider}rem;
  `,

  LabelMedium150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium150.rem] / remDivider}rem;
  `,

  LabelMedium200: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium200.rem] / remDivider}rem;
  `,

  LinkBold50: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkBold50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkBold50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkBold50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkBold50.rem] / remDivider}rem;
    text-decoration: ${linkBold50.textDecoration};
    text-underline-offset: ${linkBold50.textUnderlineOffset};
    text-decoration-thickness: ${linkBold50.textDecorationThickness};
  `,

  LinkBold100: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkBold100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkBold100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkBold100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkBold100.rem] / remDivider}rem;
    text-decoration: ${linkBold100.textDecoration};
    text-underline-offset: ${linkBold100.textUnderlineOffset};
    text-decoration-thickness: ${linkBold100.textDecorationThickness};
  `,

  LinkBold150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkBold150.rem] / remDivider}rem;
    text-decoration: ${linkBold150.textDecoration};
    text-underline-offset: ${linkBold150.textUnderlineOffset};
    text-decoration-thickness: ${linkBold150.textDecorationThickness};
  `,

  LinkBold200: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkBold200.rem] / remDivider}rem;
    text-decoration: ${linkBold200.textDecoration};
    text-underline-offset: ${linkBold200.textUnderlineOffset};
    text-decoration-thickness: ${linkBold200.textDecorationThickness};
  `,

  LinkRegular50: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular50.rem] / remDivider}rem;
    text-decoration: ${linkRegular50.textDecoration};
    text-underline-offset: ${linkRegular50.textUnderlineOffset};
    text-decoration-thickness: ${linkRegular50.textDecorationThickness};
  `,

  LinkRegular100: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular100.rem] / remDivider}rem;
    text-decoration: ${linkRegular100.textDecoration};
    text-underline-offset: ${linkRegular100.textUnderlineOffset};
    text-decoration-thickness: ${linkRegular100.textDecorationThickness};
  `,

  LinkRegular150: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular150.rem] / remDivider}rem;
    text-decoration: ${linkRegular150.textDecoration};
    text-underline-offset: ${linkRegular150.textUnderlineOffset};
    text-decoration-thickness: ${linkRegular150.textDecorationThickness};
  `,

  LinkRegular200: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular200.rem] / remDivider}rem;
    text-decoration: ${linkRegular200.textDecoration};
    text-underline-offset: ${linkRegular200.textUnderlineOffset};
    text-decoration-thickness: ${linkRegular200.textDecorationThickness};
  `,
};
